
import {mapState, mapActions, mapMutations, mapGetters} from 'vuex';
export default {
	name: 'ChatMessageWelcome',
	computed: {
		...mapGetters({
			contentH: 'chatapp/contentH',
		}),
	},
}
